import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';
import { IMetric } from '../../models/metrics/metric.interface';
import { TrackingActions } from '../../state-management/tracking/tracking.action';

@Injectable({ providedIn: 'root' })
export class MetricService {
    constructor(private store: Store<AppState>) {}

    public emit(metric: IMetric) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: metric.type,
                events: metric.fields,
            },
        });
    }
}
